// English translations for the delivery page (French string -> English).
const m: Record<string, string> = {
  // ── AdminDeliveryAmeexPage ──────────────────────────────────────────────
  'Livraison AMEEX': 'AMEEX Delivery',
  'Intégration API expédition': 'Shipping API integration',
  'Rafraîchir': 'Refresh',
  'Impossible de charger le tableau de bord AMEEX.': 'Unable to load the AMEEX dashboard.',
  'Vue d’ensemble': 'Overview',
  '{n} colis suivis': '{n} parcels tracked',
  'Aucun colis pour le moment.': 'No parcels yet.',
  'Prêts à expédier': 'Ready to ship',
  'Albums imprimés ou prêts pour la presse, sans colis AMEEX créé.': 'Albums printed or press-ready, with no AMEEX parcel created.',
  'Tout est expédié — aucune commande en attente.': 'Everything is shipped — no pending orders.',
  'Tout sélectionner ({n})': 'Select all ({n})',
  'Effacer': 'Clear',
  '{n} sélectionné(s)': '{n} selected',
  'Ouvrir / créer manuellement →': 'Open / create manually →',
  'Colis actifs': 'Active parcels',
  'Suivi en temps réel des colis confiés à AMEEX.': 'Real-time tracking of parcels handed to AMEEX.',
  'Aucun colis actif chez AMEEX.': 'No active parcels at AMEEX.',
  'Commande': 'Order',
  'Code colis': 'Parcel code',
  'Dernier événement': 'Last event',
  'Supprimer ce colis (chez AMEEX aussi)': 'Delete this parcel (at AMEEX too)',
  'Supprimer le colis {code} ({order}) ?\nIl sera supprimé chez AMEEX aussi.': 'Delete parcel {code} ({order})?\nIt will be deleted at AMEEX too.',
  'Suppression impossible : {message}': 'Could not delete: {message}',
  'Supprimer le colis {code} ? Il sera supprimé chez AMEEX aussi. La commande reste.': 'Delete parcel {code}? It will be deleted at AMEEX too. The order stays.',
  'Oui, supprimer': 'Yes, delete',
  'Suppression…': 'Deleting…',
  'AMEEX garde le colis. Tu peux le retirer seulement de cette page — supprime-le aussi dans ton espace AMEEX.': 'AMEEX keeps the parcel. You can remove it from this page only — delete it in your AMEEX account too.',
  'Retirer de la page seulement': 'Remove from this page only',
  'Étagère retours': 'Returns shelf',
  'Colis retournés à valider — cochez « Reçu en stock » sur la commande quand vous l’avez physiquement récupéré.': 'Returned parcels to validate — tick "Received back in stock" on the order once you have physically recovered it.',
  'Code {code}': 'Code {code}',
  'Retour AMEEX': 'AMEEX return',

  // ── AmeexConfirmPrint ───────────────────────────────────────────────────
  '✓ {created} créé(s), {skipped} ignoré(s), {failed} échec(s)': '✓ {created} created, {skipped} skipped, {failed} failed',
  'Erreur: {message}': 'Error: {message}',
  'Création des colis AMEEX… les étiquettes s’ouvriront ici automatiquement.': 'Creating AMEEX parcels… the labels will open here automatically.',
  'Création + impression…': 'Creating + printing…',
  'Confirmer + imprimer {n}': 'Confirm + print {n}',
  'Colis AMEEX déjà créé (commande déjà expédiée)': 'AMEEX parcel already created (order already shipped)',
  'Ville AMEEX manquante — ouvrez la commande et choisissez la ville': 'Missing AMEEX city — open the order and pick the city',
  'Adresse de livraison manquante — ouvrez la commande': 'Missing delivery address — open the order',
  'COD invalide (total − avance ≤ 0)': 'Invalid COD (total − advance ≤ 0)',
  'Commande introuvable': 'Order not found',
  'Imprimer les étiquettes': 'Print labels',
  'Bordereau': 'Manifest',

  // ── AmeexInsightsCard ───────────────────────────────────────────────────
  'Synchronisé · {n} mis à jour': 'Synced · {n} updated',
  'Échec de la synchronisation': 'Sync failed',
  'Impossible de charger les KPIs AMEEX.': 'Unable to load AMEEX KPIs.',
  'Livraisons AMEEX': 'AMEEX Deliveries',
  'Live': 'Live',
  'Direct depuis AMEEX · {n} colis': 'Direct from AMEEX · {n} parcels',
  '· maj {time}': '· upd. {time}',
  'Affiche la réponse brute d’AMEEX pour diagnostiquer pourquoi les KPIs sont à 0': 'Shows AMEEX\'s raw response to diagnose why the KPIs are at 0',
  'Diagnostic': 'Diagnostics',
  'Force la mise à jour des statuts AMEEX dans notre base (en plus du flux temps réel)': 'Forces an update of AMEEX statuses in our database (in addition to the real-time stream)',
  'Synchronisation…': 'Syncing…',
  'Sync DB': 'Sync DB',
  'Encaissé (livrés)': 'Collected (delivered)',
  '{n} colis livrés': '{n} parcels delivered',
  'En attente d’encaissement': 'Awaiting collection',
  '{n} colis en route': '{n} parcels in transit',
  'Taux de livraison': 'Delivery rate',
  'Aucun colis terminé': 'No completed parcels',
  '{delivered} sur {total} terminés': '{delivered} of {total} completed',
  'Pertes (retours + refus)': 'Losses (returns + refusals)',
  '{returned} retour · {refused} refus': '{returned} returns · {refused} refusals',
  'Répartition par statut': 'Breakdown by status',
  'Top villes (livraisons réussies)': 'Top cities (successful deliveries)',
  'Diagnostic AMEEX': 'AMEEX Diagnostics',
  'fermer': 'close',
  'En cours': 'In progress',
  'À vérifier': 'To check',

  // ── AmeexDeliveryCard ───────────────────────────────────────────────────
  'Colis {code}': 'Parcel {code}',
  'Aucun colis créé': 'No parcel created',
  'Méthode de paiement : Virement bancaire': 'Payment method: Bank transfer',
  'Le client doit avoir payé l’acompte par virement avant l’expédition. Vérifiez la réception avant de créer le colis — le COD AMEEX sera réduit du montant de l’acompte.': 'The customer must have paid the advance by transfer before shipping. Verify receipt before creating the parcel — the AMEEX COD will be reduced by the advance amount.',
  'Méthode de paiement : Paiement à la livraison': 'Payment method: Cash on delivery',
  'L’acompte se paie d’abord par virement ; AMEEX encaisse le reste à la livraison.': 'The advance is paid first by bank transfer; AMEEX collects the rest on delivery.',
  'Joignez un reçu / capture du virement — ou cliquez dans ce cadre puis collez l’image (Ctrl+V / Cmd+V).': 'Attach a receipt / transfer screenshot — or click inside this box, then paste the image (Ctrl+V / Cmd+V).',
  'Créer via API': 'Create via API',
  'Coller un code existant': 'Paste an existing code',
  'Ville AMEEX *': 'AMEEX city *',
  '✓ Détectée depuis l’adresse : {name} (id {id})': '✓ Detected from the address: {name} (id {id})',
  'Tapez pour rechercher (id envoyé à AMEEX)': 'Type to search (id sent to AMEEX)',
  'COD (MAD) *': 'COD (MAD) *',
  'Total {total} − acompte {advance} = {cod} à encaisser': 'Total {total} − advance {advance} = {cod} to collect',
  'Prix commande: {total} MAD': 'Order price: {total} MAD',
  'Acompte de {advance} MAD déjà reçu (déduit du COD)': 'Advance of {advance} MAD already received (deducted from COD)',
  'Le client a choisi virement bancaire — vérifiez que l’acompte est bien reçu avant d’expédier.': 'The customer chose bank transfer — confirm the advance was received before shipping.',
  'Adresse complète *': 'Full address *',
  'Nature de produit': 'Product nature',
  'Pré-rempli depuis Paramètres → AMEEX': 'Pre-filled from Settings → AMEEX',
  'Commentaire (optionnel)': 'Comment (optional)',
  'Instructions livreur, étage…': 'Courier instructions, floor…',
  'Fragile': 'Fragile',
  'Autoriser l’ouverture': 'Allow opening',
  'Autoriser l’essayage': 'Allow try-on',
  'Payé intégralement par virement': 'Paid in full by transfer',
  'Acompte = {total} MAD · COD = 0 · le badge « Payé » s’affichera après Enregistrer.': 'Advance = {total} MAD · COD = 0 · the "Paid" badge will show after Save.',
  'Cocher si le client a réglé la totalité (acompte = total, COD = 0).': 'Tick if the customer paid in full (advance = total, COD = 0).',
  'Acompte client (MAD)': 'Customer advance (MAD)',
  'Verrouillé sur le total tant que « Payé intégralement » est coché.': 'Locked to the total while "Paid in full" is ticked.',
  'L’argent déjà reçu sur cette commande (0 si rien). Modifiable pour cette commande.': 'The money already received on this order (0 if none). Editable for this order.',
  'Payé · {date}': 'Paid · {date}',
  'Créer le colis AMEEX': 'Create AMEEX parcel',
  'Code colis AMEEX *': 'AMEEX parcel code *',
  'Tel qu’affiché dans le tableau AMEEX': 'As shown in the AMEEX dashboard',
  'ex. AMX0234812': 'e.g. AMX0234812',
  'Ville (optionnel)': 'City (optional)',
  'Tapez pour rechercher': 'Type to search',
  'Lier le colis existant': 'Link existing parcel',
  'Ville (ID)': 'City (ID)',
  'Commentaire AMEEX': 'AMEEX comment',
  'Étiquette indisponible : {message}': 'Label unavailable: {message}',
  'Imprimer l’étiquette': 'Print label',
  'Annuler ce colis chez AMEEX ?': 'Cancel this parcel at AMEEX?',
  'Annuler le colis': 'Cancel parcel',
  'Colis reçu en stock': 'Parcel received back in stock',
  'Historique des événements ({n})': 'Event history ({n})',
  'Aucun événement reçu pour le moment.': 'No events received yet.',
  'Ville': 'City',
  'COD (MAD)': 'COD (MAD)',
  'Adresse': 'Address',
  'Commentaire': 'Comment',
  'Upload échoué': 'Upload failed',
  'Suppression échouée': 'Deletion failed',
  'Preuve de l’acompte': 'Advance proof',
  'Reçu téléversé le {date}': 'Receipt uploaded on {date}',
  'Pièce jointe seulement : téléverser une preuve ne confirme pas la commande et ne la marque pas payée.':
    'Attachment only: uploading a proof does not confirm the order or mark it paid.',
  'Joignez un reçu / capture du virement pour confirmer la réception.': 'Attach a receipt / transfer screenshot to confirm receipt.',
  'Remplacer': 'Replace',
  'Téléverser': 'Upload',
  'Retirer': 'Remove',
  'Ouvrir la preuve dans un nouvel onglet': 'Open the proof in a new tab',

  // ── AmeexCitySelect ─────────────────────────────────────────────────────
  'Tapez pour rechercher (ex. Casa, Rabat…)': 'Type to search (e.g. Casa, Rabat…)',
  'Aucune ville trouvée.': 'No city found.',
  // Ready rule (2026-10-10): approved + printed + full address; a month old → À vérifier.
  'Aperçu validé, imprimé, adresse complète — sans colis AMEEX.': 'Preview approved, printed, full address — no AMEEX parcel yet.',
  'Plus de 30 jours, jamais expédiées. Ouvre-les et décide : expédier, relancer ou annuler.': 'Over 30 days old, never shipped. Open each one and decide: ship, follow up or cancel.',
  'aperçu pas validé': 'preview not approved',
  'pas encore imprimé': 'not printed yet',
  'adresse incomplète': 'address incomplete',
  // The delivery page (2026-10-10): numbers, lanes, parcel panel, AMEEX's status names.
  'AMEEX donne la ville de chaque passage, pas la position du livreur.': 'AMEEX gives the city of each scan, not the courier’s position.',
  'AMEEX ne répond pas pour ce colis. Réessaie dans une minute.': 'AMEEX is not answering for this parcel. Try again in a minute.',
  'AMEEX n’a encore rien enregistré.': 'AMEEX has not recorded anything yet.',
  'AMEEX n’a pas encore ramassé ce colis — créé il y a {w}.': 'AMEEX has not picked up this parcel yet — created {w} ago.',
  'AMEEX n’a pas renvoyé sa liste : villes et COD peuvent manquer un instant.': 'AMEEX did not return its list: cities and COD may be missing for a moment.',
  'AMEEX te doit': 'AMEEX owes you',
  'Agent : message WhatsApp envoyé': 'Agent: WhatsApp message sent',
  'Appeler le livreur': 'Call the courier',
  'Aucun colis ici.': 'No parcel here.',
  'Aucune nouvelle d’AMEEX depuis {w}.': 'No news from AMEEX for {w}.',
  'COD livrés depuis le {d} : {cod} − frais AMEEX : {fees} − versements reçus : {paid} = {owed}': 'COD delivered since {d}: {cod} − AMEEX fees: {fees} − payouts received: {paid} = {owed}',
  'COD {n} Dh': 'COD {n} Dh',
  'Colis': 'Parcels',
  'Colis créé, jamais ramassé par AMEEX': 'Parcel created, never picked up by AMEEX',
  'Commande annulée — le colis existe encore chez AMEEX': 'Order cancelled — the parcel still exists at AMEEX',
  'Encaissé par AMEEX — aucun versement enregistré.': 'Collected by AMEEX — no payout recorded.',
  'Historique AMEEX': 'AMEEX history',
  'Impossible de charger les livraisons. La page réessaie toute seule.': 'Could not load deliveries. The page retries by itself.',
  'La liste des colis AMEEX n’a pas répondu — le montant reviendra au prochain chargement.': 'AMEEX’s parcel list did not answer — the amount comes back on the next load.',
  'Le livreur l’encaisse à la livraison.': 'The courier collects it on delivery.',
  'Le livreur n’a pas pu la joindre {n}×.': 'The courier could not reach her {n}×.',
  'Les colis bougent tout seuls quand AMEEX envoie une mise à jour.': 'Parcels move by themselves when AMEEX sends an update.',
  'Livreur': 'Courier',
  'Créé': 'Created',
  'En livraison': 'Out for delivery',
  'Livré (7 j)': 'Delivered (7 d)',
  'Livré après ton dernier versement ({d}) — pas encore versé.': 'Delivered after your last payout ({d}) — not paid yet.',
  'Livré avant ton dernier versement ({d}).': 'Delivered before your last payout ({d}).',
  'Livrés · 7 j': 'Delivered · 7 d',
  'L’agent lui a écrit sur WhatsApp à {a} — elle a répondu à {b}.': 'The agent wrote to her on WhatsApp at {a} — she replied at {b}.',
  'L’agent lui a écrit sur WhatsApp à {a} — pas encore de réponse.': 'The agent wrote to her on WhatsApp at {a} — no reply yet.',
  'Plus aucune nouvelle d’AMEEX depuis 30 jours': 'No news from AMEEX for 30 days',
  'Plus de 30 jours, jamais expédiée': 'Over 30 days old, never shipped',
  'Problème': 'Problem',
  'Refusé à la porte — {why}.': 'Refused at the door — {why}.',
  'Refusé à la porte.': 'Refused at the door.',
  'Retourné — pas encore reçu en stock': 'Returned — not back in stock yet',
  'Rien de prêt : aperçu validé, prêt à imprimer et adresse complète. {n} commandes encore en préparation.': 'Nothing ready: preview approved, ready to print and full address. {n} orders still being made.',
  'Rien à encaisser — déjà payé.': 'Nothing to collect — already paid.',
  'Ville inconnue — pas de carte.': 'Unknown city — no map.',
  'WhatsApp client': 'WhatsApp the client',
  'injoignable': 'unreachable',
  'pas encore attribué': 'not assigned yet',
  'pas ramassé': 'not picked up',
  'refusé': 'refused',
  'sans nouvelles': 'no news',
  '{n} colis livrés. Dernier versement saisi : {d}. AMEEX ne dit pas quel colis il a payé — les versements viennent de Comptabilité.': '{n} parcels delivered. Last payout entered: {d}. AMEEX does not say which parcel it paid — payouts come from Accounting.',
  '{n} en problème': '{n} with a problem',
  'À expédier': 'To ship',
  'pas encore prêt à imprimer': 'not ready to print yet',
  'Mis à disposition': 'Available for pickup',
  'Mise en distribution': 'Out for delivery',
  'Brouillon': 'Draft',
  'En cours d’expédition': 'In transit between hubs',
  'Nouveau colis': 'New parcel',
  'Ramassé': 'Picked up',
  'Reçu': 'Received at hub',
  'Relancé': 'Relaunched',
  'Relancé vers un nouveau client': 'Relaunched to a new client',
  'Relancé (suivi)': 'Relaunched (follow-up)',
  'Renvoyé vers une nouvelle ville': 'Sent to a new city',
  'Attente de ramassage': 'Waiting for pickup',
  'Annulé (suivi)': 'Cancelled (follow-up)',
  'Confirmé par le livreur': 'Confirmed by the courier',
  'Client n’a pas commandé': 'Client says she did not order',
  'Pas de réponse': 'No answer',
  'Pas de réponse + SMS': 'No answer + SMS',
  'Pas de réponse (suivi)': 'No answer (follow-up)',
  'Hors zone': 'Out of area',
  'Reporté (suivi)': 'Postponed (follow-up)',
  'Préparation du retour': 'Preparing the return',
  'En voyage': 'Travelling',
  'Injoignable': 'Unreachable',
  'Injoignable (suivi)': 'Unreachable (follow-up)',
  'Boîte vocale': 'Voicemail',
  'Boîte vocale (suivi)': 'Voicemail (follow-up)',
  'Numéro incorrect': 'Wrong number',
  'Créer les colis': 'Create the parcels',
};
export default m;
